import { trace } from 'rytm-helpers'

const ELEMENTS_SELECTOR = '.tsaw-scene-16-9'

// scale 16:9 elements to cover screen without loosing proportions (for hotpoints placement)
export const updateVnmaps = () => {
  const list = [...document.querySelectorAll(ELEMENTS_SELECTOR)]
  list.forEach(updateVnmap)
}

const updateVnmap = (el, index) => {
  const div = el.querySelector(":scope > div")
  if (div) {
    // reset
    div.setAttribute("style", null)
    setElementPosition(div)
  }
}
const setElementPosition = (div) => {
  const vW = window.innerWidth
  const vH = window.innerHeight
  const divW = div.offsetWidth
  const divH = div.offsetHeight
  // browser wider than 16:9
  if (divH > vH) {
    const offsetTop = Math.round((divH - vH) / 2)
    div.style.top = -offsetTop + "px"
  } else {
    const scale = vH / divH
    const myW = divW  * scale
    const offsetLeft = Math.round((myW - vW) / 2)
    div.style.width = myW + "px"
    div.style.height = divH  * scale + "px"
    div.style.left = -offsetLeft + "px"
  }
}